import { cn } from "@/lib/utils";
import { useCallback, useEffect, useState } from "react";

const SECTIONS = [
  { id: "sec-performance", label: "Performance" },
  { id: "sec-premium", label: "Premium / Discount" },
  { id: "sec-holdings", label: "Holdings" },
  { id: "sec-fund-facts", label: "Fund Facts" },
  { id: "sec-documents", label: "Documents" },
] as const;

export function LeveragedSectionNav() {
  const [active, setActive] = useState<(typeof SECTIONS)[number]["id"]>(SECTIONS[0].id);

  useEffect(() => {
    function onScroll() {
      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        const sec = SECTIONS[i]!;
        const el = document.getElementById(sec.id);
        if (el && el.getBoundingClientRect().top <= 120) {
          setActive(sec.id);
          return;
        }
      }
      setActive(SECTIONS[0].id);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    const navH = 57;
    const snavH = 49;
    const top = el.getBoundingClientRect().top + window.scrollY - navH - snavH - 20;
    window.scrollTo({ top, behavior: "smooth" });
  }, []);

  return (
    <div className="sticky top-[56px] z-[101] bg-[var(--etf-black)] border-b border-[var(--etf-border)] flex flex-nowrap px-10 gap-0 overflow-x-auto max-md:px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {SECTIONS.map((s) => (
        <button
          type="button"
          key={s.id}
          className={cn(
            "flex-shrink-0 font-[family-name:var(--font-instrument)] text-[12px] tracking-[0.08em] text-[var(--etf-white3)] py-3.5 mr-7 border-b-2 border-transparent cursor-pointer whitespace-nowrap transition-all duration-150 bg-transparent border-t-0 border-l-0 border-r-0",
            "hover:text-[var(--etf-white2)]",
            "max-md:mr-5 max-md:text-[11px]",
            active === s.id && "text-[var(--etf-white)] border-b-[var(--etf-orange)]",
          )}
          onClick={() => scrollTo(s.id)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
